/**
 * Spelregels voor de melder bij zijn eigen softwaremelding. Zelfde regel als
 * de database-trigger bewaak_melding_update (migratie 20261002031000): de
 * melder mag soort, omschrijving, ernst en stappen aanpassen zolang de
 * melding nieuw is en Tom er nog niet naar gekeken heeft.
 */
export function isMeldingNogAanpasbaar(m: {
  status: string;
  beoordeeld_op: string | null;
}): boolean {
  return m.status === 'nieuw' && !m.beoordeeld_op;
}

/** Kolommen die de melder zelf mag wijzigen (vóór beoordeling). */
export const MELDER_BEWERKBARE_VELDEN = ['soort', 'omschrijving', 'ernst', 'stappen'] as const;
